import React from 'react';
import { AppSelectDropdown } from '../AppSelectDropdown';
import { InfoTooltip } from '../InfoTooltip';
import { APP_SELECT_TRIGGER_CLASS } from '../../ui/controlStyles';
import {
  applyRecurrencePreset,
  buildRecurrenceFromForm,
  defaultRecurrenceForm,
  recurrencePresetId,
  recurrencePresetOptions,
  type ActivityRecurrence,
  type RecurrenceFormState,
  type RecurrencePresetId,
} from '../../utils/activityRecurrence';

export function recurrencePayloadFromForm(
  form: RecurrenceFormState,
  startYmd: string,
): ActivityRecurrence | null {
  const built = buildRecurrenceFromForm(form, startYmd);
  if ('error' in built || !('value' in built)) return null;
  return built.value;
}

type ActivityRecurrenceFieldsProps = {
  form: RecurrenceFormState;
  onChange: (next: RecurrenceFormState) => void;
  startYmd: string;
  compact?: boolean;
  menuZIndex?: number;
  /** Shown as a yellow info icon next to the label, e.g. for the automatic multi-day series. */
  hint?: string | null;
};

export function ActivityRecurrenceFields({
  form,
  onChange,
  startYmd,
  compact = false,
  menuZIndex,
  hint,
}: ActivityRecurrenceFieldsProps) {
  const preset = recurrencePresetId(form, startYmd);
  const options = recurrencePresetOptions(startYmd, preset);
  const fieldLabelClass = compact
    ? 'mb-1 block text-sm font-medium text-app-text-muted'
    : 'mb-1 block text-xs font-medium text-app-text-muted';

  return (
    <div>
      <label className={`${fieldLabelClass} flex items-center gap-1`}>
        Wiederholen
        {hint ? <InfoTooltip text={hint} className="!text-amber-500 hover:!text-amber-600" /> : null}
      </label>
      <AppSelectDropdown
        value={preset}
        onChange={(value) => onChange(applyRecurrencePreset(value as RecurrencePresetId, startYmd, form))}
        options={options}
        triggerClassName={APP_SELECT_TRIGGER_CLASS}
        menuZIndex={menuZIndex}
      />
    </div>
  );
}

export function multiDaySeriesHint(form: RecurrenceFormState): string {
  const [y, m, d] = form.untilDate.split('-');
  const days = form.freq === 'weekly' ? 'werktags' : 'täglich';
  return `Mehrtägig – wird ${days} bis ${d}.${m}.${y} angelegt. „Keine Wiederholung“ macht daraus einen durchgehenden Termin.`;
}

export { defaultRecurrenceForm };
export { buildRecurrenceFromForm };
